import React, { useEffect, useState } from 'react';
import {
  PieChart,
  Pie,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';
import analyticsService from '../../services/analyticsService';

interface DietAnalyticsProps {
  type: 'distribution' | 'detailed' | 'performance';
  dateRange: {
    from: string;
    to: string;
  };
}

const DietAnalytics: React.FC<DietAnalyticsProps> = ({ type, dateRange }) => {
  const [dietDistribution, setDietDistribution] = useState<Array<{ name: string; menus: number; description: string }>>([]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const res = await analyticsService.getDietAnalytics(dateRange);
        if (!mounted) return;
        setDietDistribution(res.distribution || []);
      } catch (error) {
        // Handle error silently
      }
    };
    load();
    return () => { mounted = false; };
  }, [dateRange]);

  if (type === 'distribution') {
    return (
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={dietDistribution}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percent }: any) => `${name} ${(percent * 100).toFixed(0)}%`}
              outerRadius={80}
              fill="#8884d8"
              dataKey="menus"
            />
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
    );
  }

  if (type === 'detailed') {
    return (
      <div className="space-y-8">
        {/* Diet Distribution */}
        <div className="bg-white rounded-lg shadow-soft p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Diet Plan Distribution</h3>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="h-64">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={dietDistribution}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={({ name, percent }: any) => `${name} ${(percent * 100).toFixed(0)}%`}
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="menus"
                  >
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </div>
            
            <div className="space-y-3">
              {dietDistribution.map((diet, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center space-x-3">
                    <div className="w-4 h-4 rounded-full bg-blue-500" />
                    <span className="font-medium text-gray-900">{diet.name}</span>
                  </div>
                  <div className="text-right">
                    <div className="font-semibold text-gray-900">{diet.menus} menus</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Removed mock performance, trends, metrics and details to avoid fake data */}
      </div>
    );
  }

  return null;
};

export default DietAnalytics;
